import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Icon } from "@mostlycode/ui"
import Section from "../Section"
import Responsive from "components/Responsive"

const StyledHeroWrapper = styled.div`
  position: relative;
  color: ${(props) => props.theme.colors.white};
`

const StyledHero = styled(Section)`
  min-height: ${(props) => props.height};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  overflow: hidden;
  position: relative;
  z-index: 20;
  padding-bottom: 6rem;
  color: ${(props) => props.theme.colors.white};

  p {
    font-size: 2rem;
    line-height: 3.2rem;
    max-width: 80%;
  }

  h1 {
    text-transform: uppercase;
    margin-top: 0;
  }

  a {
    margin-top: 4rem;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    min-height: 75vh;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 12rem 0 4rem;

    h1 {
      text-transform: uppercase;
      font-size: 5.2rem;
      line-height: 1.2;
    }

    p {
      font-size: 2.4rem;
      line-height: 1.5;
      max-width: 70rem;
      margin-left: auto;
      margin-right: auto;
    }
  `}
`

const StyledIcon = styled(Icon)`
  position: absolute;
  margin-top: 2rem;
  align-self: flex-start;
  animation: scroll 1.6s ease-out 2s 2 forwards;
  transform: translate3d(-25%, 0, 0);
  z-index: 100;
  left: 2rem;
  bottom: 2rem;

  @keyframes scroll {
    0% {
      transform: translate3d(-25%, 0, 0);
    }

    10% {
      transform: translate3d(-25%, 20%, 0);
    }

    20% {
      transform: translate3d(-25%, 0, 0);
    }

    30% {
      transform: translate3d(-25%, 20%, 0);
    }

    40% {
      transform: translate3d(-25%, 0, 0);
    }
  }
`

function Hero({ children, ...props }) {
  const height =
    typeof window !== `undefined` ? `${window.innerHeight}px` : "100vh"
  return (
    <StyledHeroWrapper>
      <StyledHero height={height} {...props}>
        {children}
      </StyledHero>
      <Responsive
        phone={<StyledIcon icon="long-arrow-down" size="md" />}
        tabletLandscape={<></>}
      />
    </StyledHeroWrapper>
  )
}

export default Hero

Hero.defaultProps = {}
Hero.propTypes = {
  children: PropTypes.node,
}
